import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { getApiCall, postApiCall } from "./tokenService";
import { UserFurtherEducationList } from "../userFurtherEducation/userFurtherEducationList";
import { UserFurtherEducationEdit } from "../userFurtherEducation/userFurtherEducationEdit";
import { ApiSaveSuccess } from "./baseService";

export const getUserFurtherEducationList = (page: number, archived: boolean): Promise<UserFurtherEducationList> => {
    return getApiCall<UserFurtherEducationList>("api/userfurthereducation?page=" + page + "&archived=" + archived.toString(), UserFurtherEducationList);
};

export const userFurtherEducationListRefresh = (page: number, archived: boolean): Promise<UserFurtherEducationList> => {
    return getApiCall<UserFurtherEducationList>("api/userfurthereducation/refresh?page=" + page + "&archived=" + archived.toString(), UserFurtherEducationList);
};

export const getUserFurtherEducationEdit = (id: string): Promise<UserFurtherEducationEdit> => {
    return getApiCall<UserFurtherEducationEdit>("api/userfurthereducation/item?id=" + id, UserFurtherEducationEdit);
};

export const saveUserFurtherEducation = (obj: any): Promise<ApiSaveSuccess> => {
    return postApiCall<ApiSaveSuccess>("api/userfurthereducation/save", ApiSaveSuccess, JSON.stringify(obj));
};

export const removeUserFurtherEducation = (id: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/userfurthereducation/remove?id=" + id, ApiSuccess);
};